/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据剧院id获取剧院名称
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetTheaterNameParams {
  constructor(public theaterId?: string) {}
}

export default async function (
  params: GetTheaterNameParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/theater-name`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
